// Utilities
import { builderFetch } from '@builder/core/utilities';
const { isEmpty } = _uo.utility;

// Translatable strings
const strings = UncannyAutomator._core.i18n.core.item.removeActionSchedule;

/**
 * Removes the schedule
 *
 * @param {Number} itemID The item ID
 * @param {("delay"|"schedule")} mode The mode
 * @return {Promise} The apiFetch promise
 */
const removeSchedule = async ( itemID, mode ) => {
	// Get the action
	const action = UncannyAutomator._core.recipe.item.getItemAction( itemID );

	// If the item is not define, stop here
	if ( isEmpty( action ) ) {
		throw new Error( `removeSchedule: The action ${ itemID } doesn't exist` );
	}

	// If the mode is not defined, stop here too
	if ( isEmpty( mode ) ) {
		throw new Error( `removeSchedule: mode must be defined` );
	}

	// Save the recipe title
	return builderFetch( {
		endpoint: 'remove_schedule',
		method: 'POST',
		data: {
			recipeId: UncannyAutomator._recipe.recipe_id,
			actionId: itemID
		},
		snackbar: {
			loading: mode === 'delay' ? strings.delayLoading : strings.scheduleLoading,
			success: mode === 'delay' ? strings.delayUpdated : strings.scheduleUpdated,
		}
	} );
}

export default removeSchedule;
